import vp from './vp'

export default {
  addBtn: 'イベントの追加',
  eventDescription:
    '定時器関連の数値を変更しないようにお勧めします。そうしないと、プレイ可能な広告が正常にトライアルできなくなる可能性があります。',
  eventComponent: {
    eventPosition: {
      updatePositionBtn: '位置を現在の値に設定する',
    },
    unit: {
      ShakeFequence: '回/s',
    },
    showElement: 'マテリアルを表示する',
    hideElement: 'マテリアルを非表示にする',
    enablePair: 'ペアリング関係を有効にする',
    banPair: 'ペアリング関係を無効にする',
    freeEnable: 'フリーハンドコンポーネントを有効にする',
    freeBan: 'フリーハンドコンポーネントを無効にする',
    showGroup: 'グループを表示',
    hideGroup: 'グループを非表示にする',
    enableEraseGroup: '消去可能なグループを有効にする',
    banEraseGroup: '消去可能なグループを無効にする',
    enableEraseComponent: '消去コンポーネントを有効にする',
    banEraseComponent: '消去コンポーネントを無効にする',
    enableMaskComponent: '有効にする',
    banMaskComponent: '無効にする',
    enableMaskGroupComponent: '表示する',
    banMaskGroupComponent: '非表示にする',
    showMaskGroup: 'グループを表示する',
    hideMaskGroup: '非表示にする',
    showMaskSubGroup: '表示する',
    hideMaskSubGroup: '非表示にする',
    enableMaskShape: '有効にする',
    banMaskShape: '無効にする',
    enableCarouselComponent: 'カルーセル有効化',
    banCarouselComponent: 'カルーセル無効化',
    enableCarousel: 'カルーセルグループ有効化',
    banCarousel: 'カルーセルグループ無効化',
    pauseCarousel: 'カルーセルグループ一時停止',
    playCarousel: 'カルーセルグループ再生',
  },
  eventBlock: {
    editBtn: 'ドラッグ領域を編集する',
    addBtn: '+指定領域を追加する',
    eventTitle: 'イベントに応答する',
    placeholder: '応答イベントを選択する',
    targetTitle: '応答オブジェクト',
    targetInfo: '必須情報',
    saveBtn: '保存',
    cancelBtn: 'キャンセル',
    addAction: '+応答イベントを追加する',
    timerEvent: 'タイマー',
    jumpToScene: '指定シーンにジャンプする',
    jumpNextScene: '次のシーンにジャンプする',
    jumpAppStore: 'アプリストアにジャンプする',
    setBuriedPoint: 'トラッキングイベントを設定する',
    setPosition: '位置を設定する',
    setSpin: '回転を設定する',
    setWidth: '幅を設定する',
    setHeight: '高さを設定する',
    materialDisplay: 'マテリアルを表示/非表示にする',
    setTransparency: '透明度を設定する',
    setColor: '色を設定する',
    executionDelay: '遅延実行',
    cancelDelay: '遅延実行をキャンセルする',
    dragDirTitle: 'ドラッグ方向',
    xDragDir: '水平方向',
    yDragDir: '垂直方向',
    anyDragDir: '任意の方向',
    dragBound: 'ドラッグ範囲',
    dragBoundFullScreen: 'フルスクリーン',
    dragBoundCustom: 'カスタム',
    dragBoundCustomDesc: 'キャンバス内でサイズを設定できます',
    dragAreaTip: '指定エリア',
    dragBoundTip: 'カスタムドラッグ範囲',
    dragTip:
      '同じレイヤーにおいて、異なるドラッグイベントの場合、ドラッグ関連の設定は一貫している必要があります。これには、ドラッグ範囲やドラッグ方向が含まれます。最新の設定が適用されます。',
    dragResetPos: 'リリース時のリセット',
    yes: 'はい',
    no: 'いいえ',
  },
  eventHand: {
    click: 'クリック',
    hold: '3秒間長押し',
    down: '押す',
    up: '離す',
    doubleClick: 'ダブルクリック',
    swipeUp: '上スワイプ',
    swipeDown: '下スワイプ',
    swipeLeft: '左スワイプ',
    swipeRight: '右スワイプ',
    swipeAny: '任意のスワイプ',
    vpDragStart: 'ドラッグ',
    vpDragPosition: '指定位置までドラッグ',
    vpUnDragPosition: '指定位置まで未ドラッグ',
    dragArea: '指定領域をドラッグする',
    delay: 'タイマーによるトリガー',
    customEvent: 'カスタムイベント',
    videoStart: '開始時',
    videoEnd: '終了時',
    audioStart: '開始時',
    audioEnd: '終了時',
    hideUI: '要素を非表示にする',
    installApp: 'アプリをダウンロードする',
    switchScene: 'シーンにジャンプする',
    fromStatus: '開始状態',
    toStatus: '終了状態',
    longPress: '長押し',
    conditionIf: '条件判断',
    drawStart: '描画開始',
    drawEnd: '描画完了',
    freeDrawStart: '描画開始',
    freeDrawEnd: '描画完了',
    eraseStart: '消去を開始する',
    eraseUp: '指を持ち上げる',
    eraseReachStep: '特定の段階に到達する',
    eraseUnReachStep: '特定の段階に未到達',
  },
  eventTarget: {
    placeholder: '応答オブジェクトを選択する',
  },
  visualProgram: {
    variableType: {
      string: '文字列',
      number: '数字',
      boolean: 'ブール値',
    },
  },
  action: vp.action,
  VpCategories: vp.VpCategories,
  component: vp.component,
}
